import type { $Enums } from '@prisma/client'


import { useState } from 'react';
interface YoutubeLinkModalData {
  musicModel: Extract<$Enums.MusicModel, 'V2' | 'V3'>
  musicType: $Enums.MusicType
}
export function useYoutubeLinkModal() {
  const [open, setOpen] = useState(false)
  const [data, setData] = useState<YoutubeLinkModalData>({
    musicModel: 'V3',
    musicType: 'Song',
  })

  const show = (data: YoutubeLinkModalData) => {
    setData(data)
    setOpen(true)
  }

  const close = () => {
    setOpen(false)
  }

  return {
    open,
    show,
    close,
    data,
  }
}
